import { render, staticRenderFns } from "./DialogGestionSectores.vue?vue&type=template&id=b93e0eaa&scoped=true"
import script from "./DialogGestionSectores.vue?vue&type=script&lang=js"
export * from "./DialogGestionSectores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93e0eaa",
  null
  
)

export default component.exports